import React, { Fragment, PureComponent } from "react";

import {
  BarChart,
  Bar,
  Tooltip,
  ResponsiveContainer,
  XAxis,
  ReferenceLine
} from "recharts";

import Loader from "./../../Loader/Loader.js";
import { Metric, StandardTooltip, selectFormat } from "./../../Utils/Utils.js";

import Heading from "./../../Elements/Heading";

const color = "#e83e8c";

class SnapChatTopsnaps extends PureComponent {
  render() {
    const { loading } = this.props;

    if (loading) {
      return <Loader minHeight={340} col={"col-12 col-md-6"} />;
    }

    const data = this.props.data.data;
    const goal = data.avg;
    data.graph =
      data.graph.length > 7
        ? data.graph.slice(0, 8).reverse()
        : data.graph.reverse();

    return (
      <div className="row snapchat--subscribers">
        <div className="col-12">
          <div className="row row--header">
            <div className="col-8">
              <Heading size={6}>New Yesterday</Heading>
              <Metric {...data.trend} size={"md"} />
            </div>
            {goal ? (
              <div className="col-4 mt-1">
                <Heading size={6} className="mb-1 avg-brand">
                  Avg/Brand
                </Heading>
                <Metric value={data.avgByBrand} size={"sm"} icon="line" />
              </div>
            ) : null}
          </div>

          <ResponsiveContainer height={230} width="100%" className="mt-5">
            <BarChart data={data.graph}>
              <Tooltip
                cursor={{ fill: "#eee", opacity: 0.5 }}
                content={
                  <StandardTooltip
                    render={({ data }) => {
                      const payload = data(this.props);
                      if (payload !== null) {
                        return (
                          <div className="standard-tooltip">
                            {Object.keys(payload).map(key => (
                              <Fragment key={key}>
                                <header className="standard-tooltip__header">
                                  <span className="standard-tooltip__key-header">
                                    {this.props.title}
                                  </span>
                                </header>
                                <main className="standard-tooltip__main">
                                  <div className="standard-tooltip__item">
                                    <span className="standard-tooltip__key">
                                      <span
                                        className="standard-tooltip__icon"
                                        style={{ background: color }}
                                      ></span>
                                      <span className="standard-tooltip__value-header">
                                        {selectFormat(
                                          "date",
                                          payload[key].payload.date,
                                          "MM/DD"
                                        )}
                                      </span>
                                    </span>
                                    <span className="standard-tooltip__value">
                                      {selectFormat(
                                        "number",
                                        payload[key].value
                                      )}
                                    </span>
                                  </div>
                                </main>
                              </Fragment>
                            ))}
                          </div>
                        );
                      }
                    }}
                  />
                }
              />
              <defs>
                <linearGradient
                  id={`color-${color}`}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop offset="5%" stopColor={color} stopOpacity={0.55} />
                  <stop offset="95%" stopColor={color} stopOpacity={1} />
                </linearGradient>
              </defs>
              <Bar
                dataKey="value"
                fillOpacity={1}
                fill={`url(#color-${color})`}
              />
              <XAxis dataKey="date" hide />
              {goal ? (
                <ReferenceLine
                  y={goal}
                  strokeDasharray="3 3"
                  stroke="#FC6D52"
                  ifOverflow="extendDomain"
                />
              ) : null}
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  }
}

export default SnapChatTopsnaps;
